import { ColDef, GetQuickFilterTextParams } from 'ag-grid-community';
import { ColumnMeta, ColumnType } from '../../../../../types';
import { getIsoDateColDef } from '../../../../../util/ag-grid-utils';

interface FilterParams extends Partial<
  Pick<
    ColDef['filterParams'],
    'maxNumConditions' | 'filterOptions' | 'excelMode' | 'applyMiniFilterWhileTyping' | 'values'
  >
> {}

interface FilterConfig {
  filter: string | boolean;
  filterParams?: FilterParams;
  getQuickFilterText?: (params: GetQuickFilterTextParams) => string;
}

const typeToAgGridTypeMap = {
  string: {
    filter: 'agTextColumnFilter',
    filterParams: {
      maxNumConditions: 1,
    },
  },
  link: {
    filter: 'agTextColumnFilter',
  },
  date: getIsoDateColDef({
    filterParams: {
      maxNumConditions: 1,
    },
  }),
  number: {
    filter: 'agNumberColumnFilter',
    filterParams: {
      maxNumConditions: 1,
      filterOptions: ['greaterThan', 'lessThan', 'equals', 'inRange'],
    },
  },
  stringArray: {
    filter: 'agSetColumnFilter',
  },
} as Record<ColumnType, FilterConfig>;

function genericQuickFilterTextGetter(params: GetQuickFilterTextParams): string {
  return params.value ?? '';
}
export function getColumnFilter(column: ColumnMeta): FilterConfig | undefined {
  if (column.name === 'Fund') {
    return { filter: 'fundComponentFilter' };
  }
  if (column?.meta?.isSet) {
    return {
      filter: 'agSetColumnFilter',
      filterParams: {
        applyMiniFilterWhileTyping: true,
        ...(!!column.meta.filterValues?.length && { values: column.meta.filterValues }),
      },
    };
  }
  return typeToAgGridTypeMap[column.type];
}

export function getFilterOptions(column: ColumnMeta): Partial<FilterConfig> | undefined {
  const filter = getColumnFilter(column);
  const getQuickFilterText = column.meta?.includeInQuickSearch ? genericQuickFilterTextGetter : undefined;
  return filter ? { ...filter, getQuickFilterText } : { getQuickFilterText };
}
